exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/core-js/modules/_object-pie.js
// module id = ../../../../core-js/modules/_object-pie.js
// module chunks = 3